import React from "react";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers";
import { dateInput } from "../../utils/formatter";
import dayjs from "dayjs";

/**
 * This overriden component makes api more similar to input of type date.
 *
 * It hides using dayjs lib.
 */

export default function DatePicker(props) {
  const [internalValue, setInternalValue] = React.useState(
    props.value ?? props.defaultValue ?? "",
  );

  const overrides = { ...props };

  overrides.onChange = function (value, context) {
    const internalValue = dateInput(value?.$d) ?? "";
    setInternalValue(internalValue);
    props?.onChange?.(internalValue, context);
  };

  if (props.value != null) {
    overrides.value = dayjs(props.value);
  }

  if (props.defaultValue != null) {
    if (props.defaultValue.length === 0) {
      delete overrides.defaultValue;
    } else {
      overrides.defaultValue = dayjs(props.defaultValue);
    }
  }

  if (props.minDate != null) {
    overrides.minDate = dayjs(props.minDate);
  }

  if (props.maxDate != null) {
    overrides.maxDate = dayjs(props.maxDate);
  }

  delete overrides.name;

  return (
    <>
      <MuiDatePicker {...overrides} />
      <input type="hidden" name={props.name} value={internalValue} />
    </>
  );
}
